declare global {
  interface Window {
    ciq?: {
      enabledFeatureFlags?: string[];
    };
  }
}

export const FEATURE_FLAG_AGENT_CHARTING = 'feature_flag_agent_charting';
export const FEATURE_FLAG_AI_COMP_ADMIN_AGENT = 'feature_flag_ai_comp_admin_agent';

export const isFeatureEnabled = (flagName: string): boolean => {
  return window.ciq?.enabledFeatureFlags?.includes(flagName) ?? false;
};
